import React from "react"
import { Box } from "@mui/material"
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined"

import { COLORS } from "../../utils"
import { getTileVisuals, getTileChips } from "../../utils/tiles"
import ExecutionCard from "../Executions/ExecutionCard"

const ProductionStepExecutionsTile = ({ tile, onClick, renderPrint }) => {
  // Get tile background color and icon based on PSE properties
  const { color: backgroundColor, border: border } = getTileVisuals(tile)
  const chipsStyle = getTileChips(tile)
  const isDefault = !tile.isReprod && !tile.isNight && !tile.isSync && tile.status !== "LOCKED" && !tile.isStepMerged

	return (
		<ExecutionCard
      onClick={onClick}
      cardSx={{ backgroundColor, border }}
      contentSx={{ backgroundColor: isDefault || tile.status === "LOCKED" ? COLORS.BACKGROUND_GREY : "rgba(255, 255, 255, 0.5)"}}
      item={tile}
      title={tile.PSEName}
      chips={chipsStyle}
      renderPrint={renderPrint}
    >
      {/* Unique Code and Section */}
        <Box sx={styles.recipeRow}>
          <Box sx={styles.uniqueCodeTag}>
            <span style={styles.uniqueCode}>
            {tile.isStepMerged ? tile.mergedProductionStepExecutions.length + " recettes" : tile.uniqueCode}
            </span>
          </Box>
          {!tile.isStepMerged && <span style={styles.sectionText}>{tile.recipeName}</span>}
        </Box>
      {/* Prior Steps */}
      {tile.remainingPriorSteps.length > 0 && (
        <Box sx={styles.priorSteps}>
          <span style={styles.priorStepsText}>En attente de :</span>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {tile.remainingPriorSteps.map((element, idx) => (
              <li key={idx} style={{ ...styles.priorStepsText, paddingBottom: idx === tile.remainingPriorSteps.length - 1 ? 0 : "8px" }}>
                {element.name} - Atelier {(element.kitchenArea).toLowerCase()}
              </li>
            ))}
          </ul>
        </Box>
      )}

      {/* Machine row */}
      {tile.machineNames.length > 0 && 
        <Box sx={{...styles.machinesRow, paddingTop: tile.machineNames.length > 0 ? "12px" : "0px", borderTop: tile.machineNames.length > 0 ? (isDefault ? `1px solid ${COLORS.PRIMARY_BORDER}` : `1px solid ${backgroundColor}`) : "none"}}>
          {tile.machineNames.map((name, index) => (
            <div key={index} style={{ ...styles.machineChip, backgroundColor: isDefault || tile.status === "LOCKED" ? `${COLORS.BACKGROUND_LIGHT_GREY}` : backgroundColor }}>
              <SettingsOutlinedIcon sx={styles.machineIcon} />
              <span>{name}</span>
            </div>
          ))}
        </Box>
      }
		</ExecutionCard>
	)
}

const styles = {
	tileWrapper: {
    position:"relative",
		borderRadius: "8px",
		padding: "16px",
		cursor: "pointer",
		transition: "box-shadow 0.2s ease",
	},
  priorSteps: {
    backgroundColor: COLORS.BLACK_200,
    padding: "8px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  priorStepsText: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: COLORS.BLACK_600,
  },
  recipeRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
  },
  machinesRow: {
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    flexWrap: "wrap"
  },
  machineChip: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "4px 8px",
    borderRadius: "8px",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: `${COLORS.BLACK800}`,
  },
  machineIcon: {
    fontSize: "24px",
    color: `${COLORS.BLACK800}`,
  },
  uniqueCodeTag: {
    backgroundColor: COLORS.WHITE,
    padding: "4px 8px",
    borderRadius: "8px",
    border: `1.5px solid ${COLORS.BLACK_200}`,
  },
  uniqueCode: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: COLORS.BLACK800,
  },
  sectionText: {
		fontSize: "16px",
		lineHeight: "24px",
		fontWeight: 400,
		color: COLORS.BLACK800,
		flex: 1,
	},
	actionRow: {
		display: "flex",
    justifyContent: "space-between",
		alignItems: "center",
		gap: "8px",
	},
}

export default ProductionStepExecutionsTile
